import { Action } from '@ngrx/store';
import { Milestone } from '@app/models/milestone';

export enum MilestoneActionTypes {
  Load = '[API] Load milestones',
  LoadSuccess = '[API] Load milestones success',
  LoadFail = '[API Load milestones fail',
  Create = '[API] Create milestone',
  CreateSuccess = '[API] Create milestone success',
  CreateFail = '[API] Create milestone fail',
  AddAll = '[Milestones] Add all',
  AddOne = '[Milestones] Add one',
  AddMany = '[Milestones] Add many',
  LoadStatuses = '[Milestones] Load statuses',
  LoadStatusesSuccess = '[Milestones] Load statuses success',
  LoadStatusesFail = '[Milestones] Load statuses fail'
}

export interface MilestoneStatus {
  name: string;
  value: number;
}

export class Load implements Action {
  readonly type = MilestoneActionTypes.Load;
  constructor(public FollowId?: number) {}
}

export class LoadSuccess implements Action {
  readonly type = MilestoneActionTypes.LoadSuccess;
  constructor(public milestones: Milestone[]) {}
}

export class LoadFail implements Action {
  readonly type = MilestoneActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class Create implements Action {
  readonly type = MilestoneActionTypes.Create;
  constructor(public data: any) {}
}

export class CreateSuccess implements Action {
  readonly type = MilestoneActionTypes.CreateSuccess;
  constructor(public milestone: Milestone) {}
}

export class CreateFail implements Action {
  readonly type = MilestoneActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class AddAll implements Action {
  readonly type = MilestoneActionTypes.AddAll;
  constructor(public milestones: Milestone[]) {}
}

export class AddOne implements Action {
  readonly type = MilestoneActionTypes.AddOne;
  constructor(public milestone: Milestone) {}
}

export class AddMany implements Action {
  readonly type = MilestoneActionTypes.AddMany;
  constructor(public milestones: Milestone[]) {}
}

export class LoadStatuses implements Action {
  readonly type = MilestoneActionTypes.LoadStatuses;
  constructor() {}
}

export class LoadStatusesSuccess implements Action {
  readonly type = MilestoneActionTypes.LoadStatusesSuccess;
  constructor(public statuses: MilestoneStatus[]) {}
}

export class LoadStatusesFail implements Action {
  readonly type = MilestoneActionTypes.LoadStatusesFail;
  constructor(public error: any) {}
}

export type MilestoneActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | Create
  | CreateSuccess
  | CreateFail
  | AddAll
  | AddOne
  | AddMany
  | LoadStatuses
  | LoadStatusesSuccess
  | LoadStatusesFail;
